import { render, staticRenderFns } from "./CopyCampaignModal.html?vue&type=template&id=289b1168&scoped=true&external"
import script from "./CopyCampaignModal.js?vue&type=script&lang=js&external"
export * from "./CopyCampaignModal.js?vue&type=script&lang=js&external"
import style0 from "./CopyCampaignModal.scss?vue&type=style&index=0&id=289b1168&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289b1168",
  null
  
)

export default component.exports